import * as guards from './guards';
import Home from '../components/Home';
import Login from '../components/auth/Login';
import OauthLogin from '../components/auth/OauthLogin';
import Welcome from '../components/Welcome';
import Layout from '../components/master/Layout';

import OrderReturnUpdatePage from '../components/Order/Return/OrderReturnUpdatePage';
import OrderReturnConfirmationPage from '../components/Order/Return/OrderReturnConfirmationPage';
import OrderReturnSuccessPage from '../components/Order/Return/OrderReturnSuccessPage';
import OrderReturnPageWrapper from '../components/Order/Return/OrderReturnPageWrapper';
import OrderUpdatePageWrapper from '../components/Order/Change/OrderUpdatePageWrapper';
import OrderUpdatePage from '../components/Order/Change/OrderUpdate';
import OrderUpdateSuccessPage from '../components/Order/Change/OrderUpdateSuccessPage';
import OrderUpdateConfirmationPage from '../components/Order/Change/OrderUpdateConfirmationPage';
import OrderUpdateHistoryPage from '../components/Order/Change/OrderUpdateHistoryPage';

import KitsilanoQueuePage from '../components/Queues/KitsilanoQueuePage';
import KitsilanoHeldOrders from '../components/Order/Hold/KitsilanoHeldOrders';
import D365WebhookMonitoringTable from '../components/D365/D365WebhookMonitoringTable';
import CreditDashboard from '../components/CreditDashboard';
import coupon from '../components/coupon';
import OrderStatusTable from '../components/Order/Flow/OrderStatusTable';
import Inventory from '../components/inventoryLookUp/inventoryLookUp';
import admin from '../components/admin';
import DropdownManagement from '../components/DropdownManagement';
import ErrorNotFound from '../components/errors/ErrorNotFound';

import Refunds from "../components/Refunds/Refunds";
import IcsPage from "../components/Ics/Ics";
import GroundShippingPage from "../components/GroundShipping/GroundShipping";

import OrderReconciliationReportGenerator from "../components/Reports/OrderReconciliationReportGenerator";
import GiftCardReport from "../components/Reports/GiftCardReport";
import BackendUiPage from "../components/BackendUi/BackendUi";
import Fulfillment from "../components/Order/Fulfillment/Fulfillment.vue";
import AftershipReconciliationReportGenerator from "../components/Reports/AftershipReconciliationReportGenerator";
import MissingOrdersPage from "../components/Order/MissingOrders/MissingOrdersPage.vue";
import PendingFbaOrdersPage from "../components/Order/PendingFbaOrders/PendingFbaOrdersPage.vue";
import UnfulfilledOrdersPage from "../components/Order/UnfulfilledOrders/UnfulfilledOrdersPage.vue";
import UncapturedOrdersPage from "../components/Order/UncapturedOrders/UncapturedOrdersPage.vue";
import BlockedCustomer from '../components/BlockedCustomer/BlockedCustomer.vue';
import AmazonReturnsSyncPage from '../components/Order/Return/AmazonReturnsSyncPage.vue';

export default [
  /**
   * Public routes
   */
  {
    path: '/home',
    name: 'home',
    component: Home,
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/login/oauth',
    component: OauthLogin,
  },

  /*
   * Credit Dashboard
   */
  {
    name: 'credit-dashboard.accounts.apply',
    path: '/b2b/:lang/new-account-application',
    alias: ['/b2b/:lang/nouvelle-demande-de-compte'],
    component: CreditDashboard.CreateAccount,
    props: true,
  },
  // Redirect to default english application
  {
    path: '/b2b/new-account-application',
    redirect: '/b2b/en/new-account-application',
  },
  // Redirect to default french application
  {
    path: '/b2b/nouvelle-demande-de-compte',
    redirect: '/b2b/fr/nouvelle-demande-de-compte',
  },

  /*
   * New Credit Application form
   */
  {
    name: 'credit-dashboard.applications.apply',
    path: '/b2b/:lang/credit-application/:token',
    alias: ['/b2b/:lang/la-demande-de-crédit/:token'],
    component: CreditDashboard.CreateApplication,
    props: true,
  },
  // Redirect to default english accounts
  {
    path: '/b2b/credit-application/:token',
    redirect: '/b2b/en/credit-application/:token',
  },
  // Redirect to default french accounts
  {
    path: '/b2b/la-demande-de-crédit/:token',
    redirect: '/b2b/fr/la-demande-de-crédit/:token',
  },
  {
    name: 'thirdparty.payment',
    path: '/b2bcc',
    component: CreditDashboard.ThirdPartyPayment,
    props: true,
  },
    // authnet payment
  {
    name: 'authnet.landing',
    path: '/b2bpmt',
    component: CreditDashboard.AuthorizeNetLanding,
    props: true,
  },
  {
    path: '/b2b/authnet-landing',
    redirect: '/b2bpmt',
  },
  {
    path: '/b2b/en/authnet-landing',
    redirect: '/b2bpmt',
  },
  // Legacy Bambora landing URLs — kept so old/emailed links keep working
  {
    path: '/b2b/bambora-landing',
    redirect: '/b2bpmt',
  },
  {
    path: '/b2b/en/bambora-landing',
    redirect: '/b2bpmt',
  },
  {
    name: 'authnet.feedback',
    path: '/b2b/:lang/authnet-feedback',
    alias: [
      '/b2b/:lang/authnet-rétroaction',
      '/b2b/:lang/authnet-feedback/approved',
      '/b2b/:lang/authnet-feedback/declined',
      // Legacy Bambora feedback URLs — kept as aliases for old/emailed links
      '/b2b/:lang/bambora-feedback',
      '/b2b/:lang/bambora-rétroaction',
      '/b2b/:lang/bambora-feedback/approved',
      '/b2b/:lang/bambora-feedback/declined',
    ],
    component: CreditDashboard.AuthorizeNetFeedback,
    props: route => ({ query: route.query }),
  },

  /*
   * Private routes
   */
  {
    path: '/',
    component: Layout,
    beforeEnter: guards.authOnly,
    children: [
      {
        path: '',
        name: 'admin',
        component: Welcome,
      },
      {
        path: '/refunds',
        name: 'refunds',
        component: Refunds
      },
      {
        path: '/order-fulfillment',
        name: 'order-fulfillment',
        component: Fulfillment
      },
      {
        path: '/ics',
        name: 'ics',
        component: IcsPage,
      },
      {
        path: '/backend-ui',
        name: 'backend-ui',
        component: BackendUiPage,
      },
      {
        path: '/ground-shipping',
        name: 'ground-shipping',
        component: GroundShippingPage,
      },
      {
        path: '/blocked-customers',
        name: 'blocked-customers',
        component: BlockedCustomer,
        beforeEnter: guards.hasPermissionsTo(['manage-blocked-customer']),
      },
      {
        path: '/coupon-management',
        name: 'coupon-management',
        component: coupon.couponListComponent,
        beforeEnter: guards.hasPermissionsTo(['read-coupons']),
      },
      {
        path: '/coupon-create',
        name: 'coupon-create',
        component: coupon.couponCreateComponent,
        beforeEnter: guards.hasPermissionsTo(['create-coupons']),
      },
      {
        path: '/coupon-copy/:original_id',
        name: 'coupon-copy',
        component: coupon.CopyCoupon,
        props: true,
        beforeEnter: guards.hasPermissionsTo(['create-coupons']),
      },
      {
        path: '/export-coupon-report',
        component: coupon.couponExportReportComponent,
        beforeEnter: guards.hasPermissionsTo(['read-coupons']),
      },

      {
        path: '/inventoryLookup',
        component: Inventory,
        beforeEnter: guards.hasPermissionsTo(['read-inventory']),
      },

      {
        path: '/credit-dashboard',
        component: CreditDashboard.CreditDashboard,
        name: 'credit-dashboard',
        beforeEnter: guards.hasPermissionsTo(['read-credit-accounts', 'read-credit-applications']),
      },
      {
        path: '/credit-dashboard/accounts/:id',
        name: 'credit-dashboard.accounts.review',
        component: CreditDashboard.AccountReview,
        props: true,
        beforeEnter: guards.hasPermissionsTo(['read-credit-accounts']),
      },
      {
        path: '/credit-dashboard/applications/invite',
        name: 'credit-dashboard.applications.invite',
        component: CreditDashboard.CreateApplicationInvite,
        beforeEnter: guards.hasPermissionsTo(['create-credit-applications']),
      },
      {
        path: '/credit-dashboard/applications/:id',
        name: 'credit-dashboard.applications.review',
        component: CreditDashboard.ApplicationReview,
        props: true,
        beforeEnter: guards.hasPermissionsTo(['read-credit-applications']),
      },
      {
        path: '/reports/order-reconciliation',
        name: 'order-recoliation-report',
        component: OrderReconciliationReportGenerator,
        beforeEnter: guards.hasPermissionsTo(['read-finance-reports']),
      },
      {
        path: '/reports/gift-card-report',
        name: 'gift-card-report',
        component: GiftCardReport,
        beforeEnter: guards.hasPermissionsTo(['read-finance-reports']),
      },
      {
        path: '/reports/aftership-reconciliation',
        name: 'aftership-reconciliation-report',
        component: AftershipReconciliationReportGenerator,
        beforeEnter: guards.hasPermissionsTo(['read-finance-reports']),//@todo
      },
      {
        path: '/order-change',
        component: OrderUpdatePageWrapper,
        beforeEnter: guards.hasPermissionsTo(['manage-order-updates']),
        children: [
          {
            path: 'update',
            component: OrderUpdatePage,
          },
          {
            path: 'confirm',
            component: OrderUpdateConfirmationPage,
          },
          {
            path: 'success',
            component: OrderUpdateSuccessPage,
          },
        ],
      },
      {
        path: '/order-change/history',
        component: OrderUpdateHistoryPage,
        beforeEnter: guards.hasPermissionsTo(['manage-order-updates']),
      },
      {
        path: '/order-return',
        component: OrderReturnPageWrapper,
        beforeEnter: guards.hasPermissionsTo(['manage-order-returns']),
        children: [
          {
            path: 'update',
            component: OrderReturnUpdatePage,
          },
          {
            path: 'confirm',
            component: OrderReturnConfirmationPage,
          },
          {
            path: 'success',
            component: OrderReturnSuccessPage,
          },
        ],
      },
      {
        path: '/monitoring/kitsilano/queues',
        component: KitsilanoQueuePage,
        beforeEnter: guards.hasPermissionsTo(['manage-monitoring']),
      },
      {
        path: '/monitoring/kitsilano/missing-orders',
        component: MissingOrdersPage,
        beforeEnter: guards.hasPermissionsTo(['manage-monitoring']),
      },
      {
        path: '/monitoring/kitsilano/pending-fba-orders',
        component: PendingFbaOrdersPage,
        beforeEnter: guards.hasPermissionsTo(['manage-monitoring']),
      },
      {
        path: '/monitoring/kitsilano/unfulfilled-orders',
        component: UnfulfilledOrdersPage,
        beforeEnter: guards.hasPermissionsTo(['manage-monitoring']),
      },
      {
        path: '/monitoring/oms/uncaptured-orders',
        component: UncapturedOrdersPage,
        beforeEnter: guards.hasPermissionsTo(['manage-uncaptured-orders']),
      },
      {
        path: '/monitoring/kitsilano/amazon-returns-sync',
        component: AmazonReturnsSyncPage,
        beforeEnter: guards.hasPermissionsTo(['manage-monitoring']),
      },
      {
        path: '/monitoring/kitsilano/hold',
        component: KitsilanoHeldOrders,
        beforeEnter: guards.hasPermissionsTo(['manage-monitoring']),
      },
      {
        path: '/monitoring/d365/webhook-table',
        component: D365WebhookMonitoringTable,
        beforeEnter: guards.hasPermissionsTo(['manage-monitoring']),
      },
      {
        path: '/monitoring/order/flow',
        name: 'order-status',
        component: OrderStatusTable,
        beforeEnter: guards.hasPermissionsTo(['manage-monitoring']),
      },

      {
        path: '/users',
        name: 'users',
        component: admin.ManageUsers,
        beforeEnter: guards.hasPermissionsTo(['read-users']),
      },
      {
        path: '/users/:user_id',
        name: 'users.manage',
        component: admin.ManageUser,
        props: true,
        beforeEnter: guards.hasPermissionsTo(['manage-access']),
      },
      {
        path: '/users/:user_id/thresholds',
        name: 'users.manage.thresholds',
        component: admin.ManageUserThresholds,
        props: true,
        beforeEnter: guards.hasPermissionsTo(['manage-thresholds']),
      },

      {
        path: '/roles',
        name: 'roles',
        component: admin.ManageRoles,
        beforeEnter: guards.hasPermissionsTo(['manage-access']),
      },
      {
        path: '/roles/create',
        name: 'roles.create',
        component: admin.CreateRole,
        beforeEnter: guards.hasPermissionsTo(['manage-access']),
      },
      {
        path: '/roles/:role_id',
        name: 'roles.manage',
        component: admin.ManageRole,
        props: true,
        beforeEnter: guards.hasPermissionsTo(['manage-access']),
      },
    ],
  },
  {
    path: '/order-change/region/:region/order/:id',
    component: OrderUpdatePageWrapper,
    beforeEnter: guards.authOnly,
    children: [
      {
        name: 'order-change-update',
        path: 'update',
        component: OrderUpdatePage,
        beforeEnter: guards.hasPermissionsTo(['manage-order-updates']),
      },
      {
        path: 'confirm',
        component: OrderUpdateConfirmationPage,
        beforeEnter: guards.hasPermissionsTo(['manage-order-updates']),
      },
      {
        path: 'success',
        component: OrderUpdateSuccessPage,
        beforeEnter: guards.hasPermissionsTo(['manage-order-updates']),
      },
    ],
  },
  {
    path: '/order-return/region/:region/order/:id',
    component: OrderReturnPageWrapper,
    beforeEnter: guards.authOnly,
    children: [
      {
        path: 'update',
        component: OrderReturnUpdatePage,
        beforeEnter: guards.hasPermissionsTo(['manage-order-returns']),
      },
      {
        path: 'confirm',
        component: OrderReturnConfirmationPage,
        beforeEnter: guards.hasPermissionsTo(['manage-order-returns']),
      },
      {
        path: 'success',
        component: OrderReturnSuccessPage,
        beforeEnter: guards.hasPermissionsTo(['manage-order-returns']),
      },
    ],
  },
  {
    path: '/manage-dropdown-lists',
    beforeEnter: guards.authOnly,
    component: Layout,
    children: [
      {
        path: 'customer-service',
        name: 'dropdown.manage.customer-service',
        component: DropdownManagement.CustomerServiceDropdownLists,
        props: true,
        beforeEnter: guards.hasPermissionsTo(['manage-dropdown-management']),
      },
      {
        path: 'finance',
        name: 'dropdown.manage.finance',
        component: DropdownManagement.FinanceDropdownList,
        props: true,
        beforeEnter: guards.hasPermissionsTo(['manage-dropdown-management']),
      },
    ]
  },

  // 404, MUST COME LAST
  {
    path: '*',
    component: ErrorNotFound,
  },
];
